/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BytesResult } from '../../models/bytes-result';

export interface ExportSinglePdfWorkPackage$Params {
  id: string;
  pdfName?: string;
}

export function exportSinglePdfWorkPackage(http: HttpClient, rootUrl: string, params: ExportSinglePdfWorkPackage$Params, context?: HttpContext): Observable<StrictHttpResponse<BytesResult>> {
  const rb = new RequestBuilder(rootUrl, exportSinglePdfWorkPackage.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
    rb.query('pdfName', params.pdfName, {});
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: 'application/octet-stream', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BytesResult>;
    })
  );
}

exportSinglePdfWorkPackage.PATH = '/v0/workPackages/{id}/export-pdf';
